import React, { useState } from 'react';
import axios from 'axios';
import { Sparkles, Loader2, WandSparkles, Languages, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AiTextHelper({ value, onResult, context = '', placeholder = '' }) {
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState(null);

  const generate = async (actionType, prompt) => {
    setLoading(true);
    setAction(actionType);
    try {
      const response = await axios.post(`${API}/ai/generate`, {
        prompt: prompt,
        context: context,
        action: actionType
      });
      onResult(response.data.result);
      toast.success('AI генерира текст успешно');
    } catch (error) {
      const errMsg = error.response?.data?.detail || 'Грешка при AI генерирането';
      toast.error(errMsg);
    } finally {
      setLoading(false);
      setAction(null);
    }
  };

  return (
    <div className="flex items-center gap-1 mt-1" data-testid="ai-text-helper">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 text-xs text-[#1B5E37] hover:bg-[#1B5E37]/10 gap-1"
        disabled={loading}
        onClick={() => generate('generate', 
          value 
            ? `Генерирай по-добро описание базирано на: "${value}"` 
            : placeholder || 'Генерирай описание за жилищен имот в София'
        )}
        data-testid="ai-generate-btn"
      >
        {loading && action === 'generate' ? <Loader2 className="w-3 h-3 animate-spin" /> : <Sparkles className="w-3 h-3" />}
        Генерирай
      </Button>

      {value && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-7 text-xs text-[#1B5E37] hover:bg-[#1B5E37]/10 gap-1"
          disabled={loading}
          onClick={() => generate('improve', `Подобри следния текст за недвижим имот, направи го по-привлекателен и професионален: "${value}"`)}
          data-testid="ai-improve-btn"
        >
          {loading && action === 'improve' ? <Loader2 className="w-3 h-3 animate-spin" /> : <WandSparkles className="w-3 h-3" />}
          Подобри
        </Button>
      )}
    </div>
  );
}
